package com.xtream.data_kmp.remote.repo

import com.xtream.data_kmp.dto.DeviceStatusResponse
import com.xtream.data_kmp.dto.PlayerPlaylistItem
import com.xtream.data_kmp.dto.PlaylistsResponse
import com.xtream.data_kmp.dto.RegisterDeviceResponse
import com.xtream.data_kmp.remote.createApiService
import io.ktor.client.call.body
import io.ktor.http.isSuccess

class PlayerServerRepo {
    
    //   fun loadXtreamAccount(
    //        scope: CoroutineScope,
    //        config: ServerConfig?,
    //        deviceInfo: DeviceInfo,
    //        onSuccess: (suspend () -> Unit)? = null,
    //        onFail: ((Throwable) -> Unit)? = null
    //    ) {

    suspend fun loadPlaylists(
        baseUrl: String,
        deviceInfo: DeviceInfo,
        apiKey: String,
        onSuccess: (suspend (PlaylistsResponse) -> Unit)? = null,
        onFail: ((Throwable) -> Unit)? = null
    ){

        try {
            val client = createApiService(baseUrl)
            val response= client.getPlaylists(
                macAddress = deviceInfo.macAddress.uppercase(),
                apiKey = apiKey

            )
            if (response.status.isSuccess()) {
                onSuccess?.invoke( response.body())
            } else {
                onFail?.invoke(Throwable("Error code ${response.status}"))
            }
        } catch (e: Exception) {
            onFail?.invoke(e)
        }


    }
    suspend fun checkStatus(
        baseUrl: String,
        deviceInfo: DeviceInfo,
        apiKey: String,
        onSuccess: (suspend (DeviceStatusResponse) -> Unit)? = null,
        onFail: ((Throwable) -> Unit)? = null

        ){



        try {
            val client = createApiService(baseUrl)
            val response= client.checkStatus(
                macAddress = deviceInfo.macAddress.uppercase(),
                apiKey = apiKey
            )

            if (response.status.isSuccess()) {

                    onSuccess?.invoke( response.body())
                } else {
                    onFail?.invoke(Throwable("Error code ${response.status}"))
                }
            } catch (e: Exception) {
                onFail?.invoke(e)
            }

    }
    suspend fun registerDevice(
        baseUrl: String,
        deviceInfo: DeviceInfo,
        apiKey: String,
        onSuccess: (suspend (RegisterDeviceResponse) -> Unit)? = null,
        onFail: ((Throwable) -> Unit)? = null
        ){
        try {


            val client = createApiService(baseUrl)
            val response = client.registerDevice(
                macAddress = deviceInfo.macAddress.uppercase(),
                deviceKey = deviceInfo.deviceId,

                apiKey = apiKey,
                model = deviceInfo.model,
                modelVersion = deviceInfo.firmwareVersion,
                appVersion = deviceInfo.versionName,
                deviceName = deviceInfo.deviceName
            )
            if (response.status.isSuccess()) {
                onSuccess?.invoke(response.body())
            } else {
                onFail?.invoke(Throwable("Error code ${response.status}"))
            }
        }catch (e: Exception) {
            onFail?.invoke(e)
        }

    }



    suspend fun editPlaylist(
        baseUrl: String,
        apiKey: String,
        playlistId: String,
        name: String,
        url: String,
        isProtected: Boolean,
        onSuccess: (suspend (PlayerPlaylistItem) -> Unit)? = null,
        onFail: ((Throwable) -> Unit)? = null
    ) {
        try {
            val client = createApiService(baseUrl)
            val response = client.editPlaylist(
                playlistId = playlistId,
                apiKey = apiKey,
                body = mapOf(
                    "name" to name,
                    "url" to url,
                    "is_protected" to isProtected
                )
            )
            if (response.status.isSuccess()) {
                onSuccess?.invoke(response.body())
            } else {
                onFail?.invoke(Throwable("Error code ${response.status}"))
            }
        } catch (e: Exception) {
            onFail?.invoke(e)
        }
    }

    suspend fun deletePlaylist(
        baseUrl: String,
        apiKey: String,
        playlistId: String,
        onSuccess: (suspend () -> Unit)? = null,
        onFail: ((Throwable) -> Unit)? = null
    ) {
        try {
            val client = createApiService(baseUrl)
            val response = client.deletePlaylist(
                playlistId = playlistId,
                apiKey = apiKey
            )
            if (response.status.isSuccess()) {
                onSuccess?.invoke()
            } else {
                onFail?.invoke(Throwable("Error code ${response.status}"))
            }
        } catch (e: Exception) {
            onFail?.invoke(e)
        }
    }



}